import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/dates/styles.css";

import React from "react";
import ReactDOM from "react-dom/client";
import { Notifications } from "@mantine/notifications";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";

import App from "@/App";
import { BrandedMantineProvider } from "@/branding/PortalTheme";
import { createQueryClient } from "@/api/client";
import { restoreSession } from "@/auth/flow";
import { ErrorBoundary } from "@/components/ErrorBoundary";

// A full page load holds no token. Try the refresh cookie before the first render, so the
// route guards wait for it instead of sending the browser to IAM and /auth/callback
// (docs#239 finding 41). It moves the auth state to `refreshing` synchronously.
void restoreSession(window.location.pathname);

const queryClient = createQueryClient();
const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element #root not found in index.html");
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    {/* The query client sits outside the theme: a lab user's theme is read from the server
        (Gate B white-labelling, D4), and Medicus staff keep the Medicus one. */}
    <QueryClientProvider client={queryClient}>
      <BrandedMantineProvider>
        <BrowserRouter>
          <Notifications position="top-right" />
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </BrowserRouter>
      </BrandedMantineProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
